import SoftBox from "components/SoftBox";
import Card from "@mui/material/Card";
import SoftTypography from "components/SoftTypography";
import { PlusIcon } from "assets/svgs/plus";
import { CheckIcon } from "assets/svgs/check";
import React, { useState } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import StatusBadge from "cxfcomponents/StatusBadge";
import UsersCell from "layouts/Flows/components/UsersCell";
import useThemeDetector from "hooks/useThemeDetector";

const Tile = ({ row }) => {
  const [shouldExpand, setShouldExpand] = useState(false);
  const { isDarkMode } = useThemeDetector();

  const renderDescription = (description) => {
    if (!shouldExpand && description?.length > 48) {
      return (
        <>
          {description?.slice(0, 48)}...
          <SoftBox
            as="span"
            display="inline-block"
            fontWeight="bold"
            fontSize="14px"
            onClick={() => setShouldExpand(true)}
            sx={{ textDecoration: "underline", cursor: "pointer", marginLeft: "4px" }}
          >
            Show more
          </SoftBox>
        </>
      );
    }

    return (
      <>
        {description}
        {description?.length > 48 && (
          <SoftBox
            as="span"
            display="inline-block"
            fontWeight="bold"
            fontSize="14px"
            onClick={() => setShouldExpand(false)}
            sx={{ textDecoration: "underline", cursor: "pointer", marginLeft: "4px" }}
          >
            Show less
          </SoftBox>
        )}
      </>
    );
  };

  return (
    <Card
      key={row.id}
      sx={{
        width: "100%",
        minWidth: "373px",
        height: "100%",
        boxShadow: isDarkMode ? "0px 20px 27px rgba(0, 0, 0, 0.05)" : "none",
        margin: "0 auto",
        padding: 3,
      }}
    >
      <SoftBox
        sx={{
          display: "flex",
          alignItems: "flex-start",
        }}
      >
        <SoftBox
          sx={{
            display: "flex",
            alignItems: "center",
            flexShrink: 0,
            // padding: "12px",
            height: {
              xs: "64px",
              sm: "64px",
              lg: "94px",
            },
            width: {
              xs: "64px",
              sm: "64px",
              lg: "94px",
            },
          }}
        >
          {row.values?.logo}
        </SoftBox>
        <SoftBox
          sx={{
            display: "flex",
            alignItems: "start",
            width: "100%",
          }}
          ml={3}
          mt={1}
          lineHeight={0}
        >
          <SoftBox>
            <SoftBox
              sx={{
                display: "flex",
                alignItems: "start",
                lineHeight: "0",
                marginRight: "8px",
              }}
            >
              <SoftBox>
                <SoftTypography
                  className="white-to-dark"
                  variant="h3"
                  fontWeight="bold"
                  marginBottom="2px"
                  fontSize="14px"
                >
                  <Link to={`/connector/${row.values?.id ?? ""}`} style={{ color: "inherit" }}>
                    {row.values?.name}
                  </Link>
                </SoftTypography>
                <StatusBadge status="active" />
              </SoftBox>
              <SoftBox
                color="text"
                component="button"
                sx={{
                  background: "none",
                  border: "none",
                  marginLeft: "16px",
                  cursor: "pointer",
                  padding: "4px",
                }}
              >
                <SoftBox
                  sx={{
                    width: "12px",
                    height: "12px",
                  }}
                >
                  {row.values?.is_owned ? <CheckIcon /> : <PlusIcon />}
                </SoftBox>
              </SoftBox>
            </SoftBox>
            <SoftTypography
              marginTop="16px"
              sx={{
                fontSize: {
                  xs: "16px",
                  sm: "12px",
                  lg: "14px",
                },
              }}
            >
              {renderDescription(row.values?.description)}
            </SoftTypography>
          </SoftBox>
          <SoftBox sx={{ marginLeft: "auto" }}>{React.cloneElement(row.values?.action)}</SoftBox>
        </SoftBox>
      </SoftBox>
      <SoftBox
        className="browse-tiles-divider"
        sx={{
          height: "1px",
          backgroundColor: "#E0E1E2",
          marginTop: "24px",
          marginBottom: "20px",
        }}
      />
      <SoftBox
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <SoftBox
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <SoftBox
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            {row.values?.developer_logo !== "" && <>{row.values?.developer_logo}</>}
            <SoftTypography
              fontWeight="medium"
              fontSize="12px"
              marginLeft="8px"
              sx={{
                textDecoration: "underline",
              }}
            >
              {row.values?.developer}
            </SoftTypography>
          </SoftBox>
          <SoftBox mt={1}>
            <UsersCell users={row.values?.users} />
          </SoftBox>
        </SoftBox>
        <SoftBox
          sx={{
            display: "flex",
            alignItems: "flex-end",
            flexDirection: "column",
          }}
        >
          <SoftTypography
            className="white-to-dark"
            sx={{
              textTransform: "uppercase",
              fontSize: "14px",
              fontWeight: "700",
              color: "#344767",
            }}
          >
            {row.values?.cost}
          </SoftTypography>
          <SoftTypography
            color="text"
            sx={{
              fontSize: "10px",
            }}
          >
            <span style={{ fontWeight: 500, fontSize: "12px" }}>Last Edited:</span>
            <span style={{ display: "inline-flex", flexDirection: "column", marginLeft: "8px" }}>
              <span>
                {row.values?.updated_date_time &&
                  moment(row.values?.updated_date_time).format("MM/DD/YY")}
              </span>
              <span style={{ lineHeight: 1 }}>
                {row.values?.updated_date_time &&
                  moment(row.values?.updated_date_time).format("h:mm:ss A")}
              </span>
            </span>
          </SoftTypography>
        </SoftBox>
      </SoftBox>
    </Card>
  );
};

const Tiles = ({ rows }) => {
  return (
    <SoftBox
      display="grid"
      sx={{
        gridTemplateColumns: "repeat(auto-fill, minmax(410px, 1fr))",
        gap: 1,
        justifyContent: "start",
        alignItems: "stretch",
        marginBottom: "16px",
      }}
    >
      {rows.map((row) => (
        <Tile row={row} key={row.id} />
      ))}
    </SoftBox>
  );
};

export default Tiles;
